
define('text!modules/strategy/supply/batch/templates/panel.html',[],function () { return '<div class="w-box w-BatchSupply">\n    <div class="view-loader"></div>\n    <div class="w-body w-panel-body"><!-- The Search & browse views render here--></div>\n    <div class="w-foot">{{>form_footer}}</div>\n</div>';});

